import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { id: "app-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSidebar = _resolveComponent("AppSidebar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppToast = _resolveComponent("AppToast")!
  const _component_notifications = _resolveComponent("notifications")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showSecure)
        ? (_openBlock(), _createBlock(_component_AppSidebar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        id: "main-app-content",
        class: _normalizeClass({ 'main-full-width': !_ctx.showSecure })
      }, [
        _createVNode(_component_router_view, { name: "header" }),
        _createElementVNode("main", _hoisted_3, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, {
                name: "page-fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_notifications, {
          group: _ctx.toastGroup,
          position: "bottom right",
          width: 380,
          max: 4,
          speed: 350,
          duration: 5000,
          "ignore-duplicates": "",
          "pause-on-hover": "",
          "close-on-click": "",
          "animation-name": "app-toast"
        }, {
          body: _withCtx(({ item, close }) => [
            _createVNode(_component_AppToast, {
              item: item,
              close: close
            }, null, 8, ["item", "close"])
          ]),
          _: 1
        }, 8, ["group"]),
        _createVNode(_component_router_view, { name: "footer" })
      ], 2)
    ])
  ]))
}